import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FuelService } from 'src/app/services/fuel.service';
import { TankService } from 'src/app/services/tank.service';
import { Fuel } from 'src/app/shared/models/Fuel';

@Component({
  selector: 'app-fuel-page',
  templateUrl: './fuel-page.component.html',
  styleUrls: ['./fuel-page.component.css']
})
export class FuelPageComponent implements OnInit {

  fuelForm: FormGroup;
  titulo = 'Crear Proveedor o Combustible';
  id: number;
  tankId: number;
  cost: number;
  hasId: boolean;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private fuelService: FuelService,
    private activatedRoute: ActivatedRoute,
    private tankService: TankService,

  ) {
    this.fuelForm = this.initFuelForm();
    this.id = parseInt(this.activatedRoute.snapshot.paramMap.get('id'), 10);
      this.hasId = Number.isNaN(this.id);

      console.log(this.hasId)

  }

  ngOnInit() {
    this.tankService.getCurrentTank().subscribe((tank) => {
      this.tankId = tank.id;
    });
    // this.route.params.subscribe(params => {
    //   this.id = params['id'];
    // });
    this.initializeEditMode();
  }

  saveFuel() {
    if (this.fuelForm.invalid) {
      return;
    }

    const fuel: Fuel = this.fuelForm.value;
    fuel.tankId = this.tankId;
// console.log("s",fuel)
// console.log("f",this.fuelForm.value)
    const saveOrUpdate = this.id
      ? this.fuelService.editFuel(this.id, fuel)
      : this.fuelService.saveFuel(fuel);

    saveOrUpdate.subscribe(
      () => this.router.navigate(['/fuels']),
      (error) => {
        console.log(error);
        this.fuelForm.reset();
      }
    );
  }

  private initFuelForm(): FormGroup {
    return this.fb.group({
      id: [''],
      name: ['', Validators.required],
      tankId: [''],
      cost: ['']
    });
  }

  /*private initializeEditMode() {
    if (this.id) {
      this.titulo = 'Editar Combustible';
      this.fuelService.getFuelByTank(this.tankId).subscribe((data) => {
        this.fuelForm.patchValue(data);
      });
    }
  }*/

  private initializeEditMode() {
    if (this.id) {
      this.titulo = 'Editar Proveedor o Combustible ';
      this.fuelService.getFuelByTank(this.tankId).subscribe((data) => {
        const filteredFuels = data.filter(fuel => fuel.id === this.id);
        if (filteredFuels.length > 0) {
          this.fuelForm.patchValue(filteredFuels[0]);
        } else {
          console.log('No se encontró ningún combustible con el ID especificado.');
        }
      });
    }
  }




}
